module.exports = __webpack_public_path__ + "img/behance.9fa5e10c.svg";